var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import FormInput from '../../ui/FormInput/FormInput';
import CredentialsForm from '../../pages/SettingsPage/forms/CredentialsForm';
import styles from './ConfirmPasswordModal.styl';
let ConfirmPasswordModal = class ConfirmPasswordModal extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onConfirmClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onConfirm();
            }
        });
        Object.defineProperty(this, "onDeclineClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onDecline();
            }
        });
        Object.defineProperty(this, "onKeyPress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const ENTER_KEY_CODE = 13;
                if (event.charCode === ENTER_KEY_CODE) {
                    this.props.onConfirm();
                }
            }
        });
    }
    render() {
        const { t } = this.props;
        const oldPasswordField = CredentialsForm.$('oldPassword');
        const buttonDisabled = CredentialsForm.validating || !oldPasswordField.changed || !oldPasswordField.isValid;
        return (React.createElement("div", { className: styles.confirmModal },
            React.createElement("div", { className: styles.content },
                React.createElement("h4", { className: styles.heading }, t('confirmPasswordModal.confirmPasswordTitle')),
                React.createElement("p", { className: styles.text }, t('confirmPasswordModal.confirmPasswordText')),
                React.createElement("div", { className: styles.input },
                    React.createElement(FormInput, { t: t, field: oldPasswordField, errorPosition: 'BottomLeft', type: 'password', onKeyPress: this.onKeyPress }))),
            React.createElement("div", { className: styles.controls },
                React.createElement(Button, { className: styles.button, variant: 'outlined', onClick: this.onDeclineClick }, t('confirmPasswordModal.discardButton')),
                React.createElement(Button, { className: styles.button, variant: 'filled', disabled: buttonDisabled, onClick: this.onConfirmClick }, t('confirmPasswordModal.saveButton')))));
    }
};
ConfirmPasswordModal = __decorate([
    observer
], ConfirmPasswordModal);
export default ConfirmPasswordModal;
